import { $_app_server } from '@/_helpers'

export const publicationService = {
    titleSugestList
  }

  function titleSugestList(text) {
    return $_app_server.post("public/titlesuggestion",text)
      .then(response => {
          return response.data
      })
  }